import http from "./http";

export default {
  //访问安心保落地页埋点
  visitInsuranceTrackingApi(params) {
    return http.post("activity/landing/visit", params);
  },
  // 用户离开安心保落地页埋点
  leaveInsuranceTrackingApi(params) {
    return http.post("activity/landing/leave", params);
  },
  // 点击海报保存按钮埋点
  clickPosterSaveTrackingApi(params) {
    return http.post("activity/landing/bill_click", params);
  },
  // 点击我要咨询按钮埋点
  clickConsultTrackingApi(params) {
    return http.post("activity/landing/consult_click", params);
  },
  // 点击播放视频按钮埋点
  clickVideoPlayTrackingApi(params) {
    return http.post("activity/landing/video_click", params);
  },
  // 点击我要投保按钮埋点
  clickInsureTrackingApi(params) {
    return http.post("activity/landing/insure_click", params);
  },
};
